import * as ambassadorWixBenefitProgramsV1ProgramDefinition from './benefit-programs-v1-program-definition-program-definitions.http.js';
import * as ambassadorWixBenefitProgramsV1ProgramDefinitionTypes from './benefit-programs-v1-program-definition-program-definitions.types.js';
import * as ambassadorWixBenefitProgramsV1ProgramDefinitionUniversalTypes from './benefit-programs-v1-program-definition-program-definitions.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function createProgramDefinition(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixBenefitProgramsV1ProgramDefinitionUniversalTypes.CreateProgramDefinitionRequest,
  ambassadorWixBenefitProgramsV1ProgramDefinitionTypes.CreateProgramDefinitionRequest,
  ambassadorWixBenefitProgramsV1ProgramDefinitionUniversalTypes.CreateProgramDefinitionResponse,
  ambassadorWixBenefitProgramsV1ProgramDefinitionTypes.CreateProgramDefinitionResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixBenefitProgramsV1ProgramDefinition.createProgramDefinition(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/program-definitions',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateProgramDefinition(): __PublicMethodMetaInfo<
  'PATCH',
  { programDefinitionId: string },
  ambassadorWixBenefitProgramsV1ProgramDefinitionUniversalTypes.UpdateProgramDefinitionRequest,
  ambassadorWixBenefitProgramsV1ProgramDefinitionTypes.UpdateProgramDefinitionRequest,
  ambassadorWixBenefitProgramsV1ProgramDefinitionUniversalTypes.UpdateProgramDefinitionResponse,
  ambassadorWixBenefitProgramsV1ProgramDefinitionTypes.UpdateProgramDefinitionResponse
> {
  const payload = { programDefinition: { id: ':programDefinitionId' } } as any;

  const getRequestOptions =
    ambassadorWixBenefitProgramsV1ProgramDefinition.updateProgramDefinition(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v1/program-definitions/{programDefinition.id}',
    pathParams: { programDefinitionId: 'programDefinitionId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deleteProgramDefinition(): __PublicMethodMetaInfo<
  'DELETE',
  { programDefinitionId: string },
  ambassadorWixBenefitProgramsV1ProgramDefinitionUniversalTypes.DeleteProgramDefinitionRequest,
  ambassadorWixBenefitProgramsV1ProgramDefinitionTypes.DeleteProgramDefinitionRequest,
  ambassadorWixBenefitProgramsV1ProgramDefinitionUniversalTypes.DeleteProgramDefinitionResponse,
  ambassadorWixBenefitProgramsV1ProgramDefinitionTypes.DeleteProgramDefinitionResponse
> {
  const payload = { programDefinitionId: ':programDefinitionId' } as any;

  const getRequestOptions =
    ambassadorWixBenefitProgramsV1ProgramDefinition.deleteProgramDefinition(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v1/program-definitions/{programDefinitionId}',
    pathParams: { programDefinitionId: 'programDefinitionId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getProgramDefinition(): __PublicMethodMetaInfo<
  'GET',
  { programDefinitionId: string },
  ambassadorWixBenefitProgramsV1ProgramDefinitionUniversalTypes.GetProgramDefinitionRequest,
  ambassadorWixBenefitProgramsV1ProgramDefinitionTypes.GetProgramDefinitionRequest,
  ambassadorWixBenefitProgramsV1ProgramDefinitionUniversalTypes.GetProgramDefinitionResponse,
  ambassadorWixBenefitProgramsV1ProgramDefinitionTypes.GetProgramDefinitionResponse
> {
  const payload = { programDefinitionId: ':programDefinitionId' } as any;

  const getRequestOptions =
    ambassadorWixBenefitProgramsV1ProgramDefinition.getProgramDefinition(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/program-definitions/{programDefinitionId}',
    pathParams: { programDefinitionId: 'programDefinitionId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getProgramDefinitionByExternalIdAndNamespace(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixBenefitProgramsV1ProgramDefinitionUniversalTypes.GetProgramDefinitionByExternalIdAndNamespaceRequest,
  ambassadorWixBenefitProgramsV1ProgramDefinitionTypes.GetProgramDefinitionByExternalIdAndNamespaceRequest,
  ambassadorWixBenefitProgramsV1ProgramDefinitionUniversalTypes.GetProgramDefinitionByExternalIdAndNamespaceResponse,
  ambassadorWixBenefitProgramsV1ProgramDefinitionTypes.GetProgramDefinitionByExternalIdAndNamespaceResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixBenefitProgramsV1ProgramDefinition.getProgramDefinitionByExternalIdAndNamespace(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/program-definitions/by-namespace-and-external-id',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryProgramDefinitions(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixBenefitProgramsV1ProgramDefinitionUniversalTypes.QueryProgramDefinitionsRequest,
  ambassadorWixBenefitProgramsV1ProgramDefinitionTypes.QueryProgramDefinitionsRequest,
  ambassadorWixBenefitProgramsV1ProgramDefinitionUniversalTypes.QueryProgramDefinitionsResponse,
  ambassadorWixBenefitProgramsV1ProgramDefinitionTypes.QueryProgramDefinitionsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixBenefitProgramsV1ProgramDefinition.queryProgramDefinitions(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/program-definitions/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  ProgramDefinition as ProgramDefinitionOriginal,
  ExtendedFields as ExtendedFieldsOriginal,
  ProgramDefinitionTranslated as ProgramDefinitionTranslatedOriginal,
  ProgramDefinitionTranslationDeleted as ProgramDefinitionTranslationDeletedOriginal,
  CreateProgramDefinitionRequest as CreateProgramDefinitionRequestOriginal,
  CreateProgramDefinitionResponse as CreateProgramDefinitionResponseOriginal,
  UpdateProgramDefinitionRequest as UpdateProgramDefinitionRequestOriginal,
  UpdateProgramDefinitionResponse as UpdateProgramDefinitionResponseOriginal,
  DeleteProgramDefinitionRequest as DeleteProgramDefinitionRequestOriginal,
  Cascade as CascadeOriginal,
  CascadeWithLiterals as CascadeWithLiteralsOriginal,
  DeleteProgramDefinitionResponse as DeleteProgramDefinitionResponseOriginal,
  GetProgramDefinitionRequest as GetProgramDefinitionRequestOriginal,
  GetProgramDefinitionResponse as GetProgramDefinitionResponseOriginal,
  GetProgramDefinitionByExternalIdAndNamespaceRequest as GetProgramDefinitionByExternalIdAndNamespaceRequestOriginal,
  GetProgramDefinitionByExternalIdAndNamespaceResponse as GetProgramDefinitionByExternalIdAndNamespaceResponseOriginal,
  QueryProgramDefinitionsRequest as QueryProgramDefinitionsRequestOriginal,
  CursorQuery as CursorQueryOriginal,
  CursorQueryPagingMethodOneOf as CursorQueryPagingMethodOneOfOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  CursorPaging as CursorPagingOriginal,
  QueryProgramDefinitionsResponse as QueryProgramDefinitionsResponseOriginal,
  CursorPagingMetadata as CursorPagingMetadataOriginal,
  Cursors as CursorsOriginal,
  UpsertProgramDefinitionRequest as UpsertProgramDefinitionRequestOriginal,
  UpsertProgramDefinitionResponse as UpsertProgramDefinitionResponseOriginal,
  GetOrCreateProgramDefinitionRequest as GetOrCreateProgramDefinitionRequestOriginal,
  GetOrCreateProgramDefinitionResponse as GetOrCreateProgramDefinitionResponseOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
} from './benefit-programs-v1-program-definition-program-definitions.types.js';
